import React from 'react';
import {
  InfoCardContent,
  InfoCardWrapper,
  InstructionContent,
  InstructionTitle,
  PanelWrapper,
  StyledInstruction,
  TuwInstructionItem,
  TuwInstructionList,
  TuwInstructionNumber,
} from './InfoCard.styled';
import { useModal } from '@sky-distribution/react-commons-ui';
import ExampleCar from '../../assets/example_car.jpg';
import { useTypedTranslate } from '../../translations/useTypedTranslate';
import { icons } from '../../icons';
import { Tenant, TENANT_NAME } from '../../config/tenants';
import ReactMarkdown from 'react-markdown';

const InfoCardIcon = icons[TENANT_NAME as Tenant].Infotip;
const isTuw = TENANT_NAME === Tenant.TUW;

export const InfoCard: React.FC = () => {
  const { t } = useTypedTranslate();
  const tuwInstructions = [t('INFO_CARD_CONTENT_1'), t('INFO_CARD_CONTENT_2')];

  const { component, setIsVisible } = useModal({
    parent: document.getElementById('root'),
    content: (
      <div>
        <InstructionTitle variant="h2">{t('MAKE_PHOTO_INSTRUCTION_TITLE')}</InstructionTitle>
        <InstructionContent variant="chipsMedium">{t('MAKE_PHOTO_INSTRUCTION_CONTENT')}</InstructionContent>
        <img src={ExampleCar} width="100%" />
      </div>
    ),
    isBlurred: true,
    isNarrow: true,
    isClosable: true,
  });

  return (
    <InfoCardWrapper>
      <PanelWrapper>
        <InfoCardIcon style={{ margin: 10, minWidth: 24 }} />
        <InfoCardContent>
          <ReactMarkdown>{t('INFO_CARD_TITLE')}</ReactMarkdown>
        </InfoCardContent>
      </PanelWrapper>
      {isTuw ? (
        <TuwInstructionList>
          {tuwInstructions.map((instruction, index) => (
            <TuwInstructionItem key={instruction}>
              <TuwInstructionNumber>{index + 1}.</TuwInstructionNumber>
              <InfoCardContent>
                <ReactMarkdown>{instruction.replace(/^\s*\d+\.\s*/, '')}</ReactMarkdown>
              </InfoCardContent>
            </TuwInstructionItem>
          ))}
        </TuwInstructionList>
      ) : (
        <>
          <InfoCardContent>
            <ReactMarkdown>{t('INFO_CARD_CONTENT_1')}</ReactMarkdown>
          </InfoCardContent>
          <StyledInstruction variant="h4" onClick={() => setIsVisible(true)}>
            {t('MAKE_PHOTO_INSTRUCTION_TITLE')}
          </StyledInstruction>
          <InfoCardContent>
            <ReactMarkdown>{t('INFO_CARD_CONTENT_2')}</ReactMarkdown>
          </InfoCardContent>
        </>
      )}
      <>{component}</>
    </InfoCardWrapper>
  );
};
